<template>
	<div
		v-testid="'skeleton'"
		:class="$style['skeleton']"
	>
		<slot />
	</div>
</template>

<script>
export default {
	name: 'Skeleton'
}
</script>

<style lang="scss" module>
.skeleton {
		width: 100%;
		position: relative;
		margin-left: auto;
		margin-right: auto;
	}
</style>
